import { Types } from "../types/Types";

const initialState = {
    isAuthenticated: sessionStorage.getItem("isAuthenticated") === "true",
    userRedirect: sessionStorage.getItem("userRedirect"),
    idioma: sessionStorage.getItem("idioma")
}

export const AuthReducer = ( state = initialState, action ) =>{
    
    const userData = sessionStorage.getItem("isAuthenticated") === "true" 
        && sessionStorage.getItem("userData") && sessionStorage.getItem("userData") !== "" 
        ?  JSON.parse(sessionStorage.getItem("userData") ) : {};
    switch (action.type) {
        case Types.authenticatedUser:
            return{
                ...userData,
                ...state,
                ...action.payload
            }

        case Types.unauthenticatedUser:
            return{
                isAuthenticated : false,
                userRedirect: ''
            }

        default:
            return state;
    }
}